import { useMutation } from '@tanstack/react-query'
import { billingApi, type OneshotOrder } from '../../utils/api'

/**
 * ワンショット課金の決済作成（BillingPage）。
 * 成功時は現行どおり外部決済ページへ遷移する。
 */
export function useCreateOneshotPayment() {
  return useMutation({
    mutationFn: (order: OneshotOrder) => billingApi.createOneshotPayment(order),
    onSuccess: (data: { url: string }) => {
      window.location.href = data.url
    },
  })
}
